import styled from 'styled-components';
import { defaultTransition } from 'styles/utils';
import Icon from 'components/Icon';

export const CaretIcon = styled(Icon)`
  margin: 0.5rem;
  transform-origin: center center;
  transform: rotate(${props => (props.show ? 0 : 180)}deg);
  ${defaultTransition('transform')}
`;
